export default __webpack_public_path__ + "static/media/gattoTtsIt_It60.cd4754d4.mp3";